import { TYPE_BOOL, TYPE_FLOAT, TYPE_INTEGER, TYPE_STRING, virtel_field_schema_lib, virtel_field_schema_smart_get, _all_fields } from "./ter-virtel-definition-lib-fields";
import { sect } from "./virtel-consts";
// import { js_utils } from '../utils/js-utils.js';


/*
TODO:
- razmotriti notslaveof property
*/


// VIRT DEFINITIONS LIB
// console.log(sect)

let schema_lib_initialized = false;
let schema_lib_optimized = {};


const SECT_INSTANCE = sect.SECT_INSTANCE; //
const SECT_GENUS = sect.SECT_GENUS; //
const SECT_FRONTEND = sect.SECT_FRONTEND; //
const SECT_NESVRSTANI = sect.SECT_NESVRSTANI; //

/*
sect.SECT_HEADER = 'sect_header';
sect.SECT_INSTANCE = 'sect_instance'; // polja koja ne uticu na ident
sect.SECT_GENUS = 'sect_genus'; // polja koja uticu na genus tj. ident
sect.SECT_FIXED = 'sect_fixed'; // sect za fixed_fields
sect.SECT_DB = 'sect_db'; // polja koja se koriste samo u bazi podataka
sect.SECT_FRONTEND = 'sect_frontend'; // polja koja se koriste samo na formama u frontendu
sect.SECT_NESVRSTANI = 'sect_NESVRSTANI'; // za polja za koja nije jos odluceno
*/


/*
PROGRAM
moguca polja za program su sledeca
program: {
    default_graphlevel: 3,
    frontend_only: true, // ne slati na backend i ignorisati na backendu
    use_classic_table: true, // jedan virtel ide u jednu tabelu.  usuprtonom se koristi par genus i instance
    use_genus: false, // ???
    use_autocreate: false // ???
}

NAPOMENA: i tipovi podataka koji se ne salju na backend moraju da imaju seme kako bi bilo pregledno i kako bi mogli da pristupamo njihovim karakteristikama iz pomocnih funkcija na jedinstven nacin.
*/

/*
fixed_fields je objekat koji sadrzi polja koja su uvek ista imaju uvek isti i key i value i ne moraj uda se unoase u forme i ne moraju da se cuvaju u bazi. Nakon ucitavanja iz baze ova polja treba da se automatski upisu u virtele.
*/


/*
NOVOSTI:
nova propertiji u definiciji filedova su primer, readme, opis/desc, path
default (default value za to polje d ase upisuje odmah pri primeni seme)

nova cesta polja su
_parent_subkey, _temid, 

*/

/*
sema podrzava skracenu sintaksu u sema.fields u kojoj umesto objecta moze da se stavi samo string sa nazivom polja (primer kod vrste pogona).

PRAVILA:
_c_ u nazivima šema oznacava da je taj virtel child od virtela napisanog sa leve strane od _c_.

polja koja pocinju sa flag_ su boolean mogu biti ili true ili false
polja koja pocinju sa multiflag_ su stringovi koji sluze da se detektuje vise tipova entitija koji idu u istu tabelu ali se mogu razlikovati prema toma koja polja se koriste.

*/




// readme: "Ovo je sema sa fieldovima koje sadrze prakticno svi virteli",
export const _schema_default_fields = [
  "rev_id",
  "superkey",
  // "id",
  "subkey",
  "parent_subkey",
  "virtelschemakey",
  "virtelclass", // ide pre terkatogorija i tergrupa jer se na osnovu njega (iz biblioteka parametara mogu odrediti) i pomenuta dva
  "flag_paired_with_smartel",
  "bomlevel",
  "graphlevel",
  "graphpath",
  "db_join_with_genus",
  "genus_ident",
  // "db_instance_flag_standalone",
  // "db_instance_flag_genus",
  "terkategorija",
  "tergrupa",
  "teridentprefix", // NOVO 2023-11-08
  "kolicina",
  "jm",
  "bomlevel_imported", // NOVO 2023 April
  "multitranslator_lang", // NOVO 2023-10-22
  "virtel_note", // NOVO 2023-09-10
  "masa_po_jm", // NOVO 2024-04-23
  "flag_masa_po_jm_custom", // NOVO 2024-05-14
  "masa_po_jm_custom", // NOVO 2024-05-14
  "masa_kumulativno", // NOVO 2024-04-23
  "flag_cena_po_jm_custom", // NOVO 2024-11-14
  "cena_po_jm_custom", // NOVO 2024-11-14
  "cena_kumulativno", // NOVO 2024-11-14
];
/*
{
  name: "calculated_ident",
  sect: SECT_INSTANCE,
  pods: {
    pods_meta: true,
  },
  type: TYPE_INTEGER,
  size: 12
},
{
  name: "readme",
  sect: SECT_INSTANCE,
  pods: {
    pods_meta: true,
  },
},
*/


const default_schema_fields_parent_subkey = [
  "parent_subkey"
];
const default_schema_fields_parametri_za_pp = [
  "operacija",
  "rc",
  "angazovanihradnika",
  "angazovanihradnika",
  "vremepripreme",
  "vremeoperacije",
  "vremeugradnje",
  "vremekumulativno"
];
const default_schema_fields_parametri_za_m = [
  "vremeugradnje"
];
const default_schema_fields_CHILDOFMODUL = [
  // "_draftelschemakey"
];

const default_schema_fields_flag_custom_pods_input = [
  "flag_custom_pods_input"
];


/*
ZA SADA OVE NAMERNO NISMO STAVILI U DEFAULTNE:
  parent_subkey
{
  name: "extra",
  sect: SECT_INSTANCE,
  pods: {
    pods_meta: true,
  },
},
{
  name: "derivati",
  sect: SECT_INSTANCE,
  pods: {
    pods_meta: true,
  },
} 

// mozda treba i ovako nesto
{
    name: "virtelpath",
    sect: SECT_INSTANCE,
    pods: {
      pods_meta: true,
    },
}
*/

//
const _pods_input_obj_make = (name) => {
  return {
    name: name,
    sect: SECT_INSTANCE,
    pods: {
      pods_input: true,
    },
  };
};
const _pods_input_obj_arr_make = (...args) => {
  let _arr = [];
  args.forEach((name) => {
    if (typeof name === 'string' && name !== '') {
      _arr.push({
        name: name,
        sect: SECT_INSTANCE,
        pods: {
          pods_input: true,
        },
      });
    }
  });
  return _arr;
};


const schema_lib = {};


//
schema_lib.terkk$temp = {
  program: {
    // default_graphlevel: 4,
    use_classic_table: true,
    mip_is_materijal: false,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    // virtelclass: "terkk$limcustom",
    // terkategorija: "PP"
    // terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_pp,

  ]
};


// terkk$klimakomora

schema_lib.terkk$klimakomora = {
  // TODO
  /*

  default_graphlevel - prema teoriji grafova... This is the depth of a node plus 1, although some[11] define it instead to be synonym of depth. A node"s level in a rooted tree is the number of nodes in the path from the root to the node. For instance, the root has level 1 and any one of its adjacent nodes has level 2. 
  */
  program: {
    default_graphlevel: 1,
    use_classic_table: true,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$klimakomora",
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "AHU",
    terkknivo: "klimakomora",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_pp,

    "pozicijemodula",
    "sifrakomore",
    "nazivkomore",
    "nazivsistema",
    "tipkomore",
    "vrstaprofila",
    "tipispuneklimakomore",
    "unutrasnjaoplata",
    "flag_dvevelicine",
    "flag_dimenzijekomoreunc",
    "flag_dimenzijekomore2unc",
    "_sirinakomoreoznaka",
    "_visinakomoreoznaka",
    "_sirinakomore2oznaka",
    "_visinakomore2oznaka",
    "_sirinakomoreunc",
    "_visinakomoreunc",
    "_sirinakomore2unc",
    "_visinakomore2unc",
    "sirinakomoreoznaka",
    "visinakomoreoznaka",
    "sirinakomoreunc",
    "visinakomoreunc",
    "sirinakomore2oznaka",
    "visinakomore2oznaka",
    "sirinakomore2unc",
    "visinakomore2unc",
    "kolicina",

    "Par6",
    "Par7",
    "Par8",
    "Par9",
    "Par10",
    "Par11",
    "Par12",
    "Par13",
    "Par14",
    "Par15",
    "Par16",
    "Par17",
    "Par18",

    "vremeopsklapanje",

    // derivati
    "ksirinaoznaka",
    "ksirinaunutrasnja",
    "ksirinaunutrasnjaizmedjupregradnih",
    "ksirinaunutrasnjaizmedjuosnovnih",
    "ksirinaunutrasnjaizmedjukrilaca",
    "ksirinaspoljasnja",
    "ksirina2oznaka",
    "ksirina2unutrasnja",
    "ksirina2unutrasnjaizmedjupregradnih",
    "ksirina2unutrasnjaizmedjuosnovnih",
    "ksirina2unutrasnjaizmedjukrilaca",
    "ksirina2spoljasnja",
    "kvisinaoznaka",
    "kvisinaunutrasnja",
    "kvisinaunutrasnjaizmedjupregradnih",
    "kvisinaunutrasnjaizmedjuosnovnih",
    "kvisinaunutrasnjaizmedjukrilaca",
    "kvisinaspoljasnja",
    "kvisina2oznaka",
    "kvisina2unutrasnja",
    "kvisina2unutrasnjaizmedjupregradnih",
    "kvisina2unutrasnjaizmedjuosnovnih",
    "kvisina2unutrasnjaizmedjukrilaca",
    "kvisina2spoljasnja",
  ]
};



// terkk$modul

schema_lib.terkk$modul = {
  // TODO
  program: {
    default_graphlevel: 2,
    use_classic_table: true,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$modul",
    jm: "kom",
    kolicina: 1,
    terkategorija: "PP",
    tergrupa: "MODUL",
    terkknivo: "modul",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_pp,

    // pods_input modul
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "sifrakomore",
      "vrstaprofila",
      "flag_dvevelicine",
      "ksirinaspoljasnja",
      "kvisinaspoljasnja",
      "ksirina2spoljasnja",
      "kvisina2spoljasnja",
    ),

    "calculated_ident",
    "siframodula",
    "brojmodula",
    "nazivmodula",
    "flag_dimenzijemodulaunc",
    // "_flag_dimenzijemodulaunc",
    "inputis_flag_dvevelicine",
    "kojavelicina",
    "sirinamodulaunc",
    "visinamodulaunc",
    "duzinamodula",
    "brojkomadaprofilpregradnisirinski",
    "brojkomadaprofilpregradnivisinski",

    "Par4",
    "Par5",
    "modul_vrsta_pakovanja",
    "modul_vrsta_pakovanja_preporucena",

    "vremeopsklapanje",

    // derivati
    "msirinaunutrasnja",
    "msirinaunutrasnjaizmedjupregradnih",
    "msirinaunutrasnjaizmedjuosnovnih",
    "msirinaunutrasnjaizmedjukrilaca",
    "msirinaspoljasnja",
    "mvisinaunutrasnja",
    "mvisinaunutrasnjaizmedjupregradnih",
    "mvisinaunutrasnjaizmedjuosnovnih",
    "mvisinaunutrasnjaizmedjukrilaca",
    "mvisinaspoljasnja",
    // "_arr_profilpregradniunc",
  ]
};



// modul rogalj i modul profili

schema_lib.terkk$modul$rogalj = {
  // TODO:
  program: {
    default_graphlevel: 3,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    virtelclass: "terkk$modul$rogalj",
    jm: "kom",
    terkategorija: "M",
    tergrupa: "rogalj",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$modul$rogalj",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_m,

    // pods_input modulrogalj
    ..._pods_input_obj_arr_make(
      "vrstaprofila"
    ),

    "tip",
    "naziv",
    "kolicina",
  ]
};

schema_lib.terkk$modul$profilosnovni = {
  // TODO: ovo su profili od modula... treba resiti svasta...
  program: {
    default_graphlevel: 3,
    use_genus: true,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "PP",
    tergrupa: "PROFIL",
    terkknivo: "CHILDOFMODUL",
    // _draftelschemakey: "terkk$modul$profilosnovni",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    // profil osnovni pods_input
    ..._pods_input_obj_arr_make(
      "vrstaprofila",
      "msirinaspoljasnja",
      "mvisinaspoljasnja",
      "duzinamodula",
    ),

    "tip",
    "naziv",
    "duzina",
    "leviger",
    "desniger",
  ]
};

schema_lib.terkk$modul$profil_materijal1 = {
  // TODO:
  program: {
    default_graphlevel: 4,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "naziv",
    "calculated_ident",
    "tip",
    "duzina",
  ]
};

schema_lib.terkk$modul$profilpregradni = {
  // TODO: ovo su profili od modula... treba resiti svasta...
  program: {
    default_graphlevel: 3,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    terkategorija: "PP"
  },
  fields: [
    ...schema_lib.terkk$modul$profilosnovni.fields
  ]
};


// terkk$panel

const _panel_schema_program_svi = {
  default_graphlevel: 3,
  use_genus: true,
  use_autocreate: false
};
const _panel_schema_fields_svi = [
  ..._schema_default_fields,
  ...default_schema_fields_parent_subkey,
  ...default_schema_fields_CHILDOFMODUL,
  ...default_schema_fields_parametri_za_pp,

  "virtelclass",
  "termaterijal",
  "sistempanela",
  "tipunosapanela",
  "multiflag_tippanela",
  "tippanela",
  "panel_lim_spoljasnji_tip",
  "panel_lim_unutrasnji_tip",
];

schema_lib.terkk$panel = {
  // TODO: elimintaor_kapi ZAHTEVA NOVO RESENJE jer je neobican i naknadno se izracujava... i sastoji se od nekolko dinamickiih pod formi
  program: {
    ..._panel_schema_program_svi
  },
  fixed_fields: {
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "PANEL",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$panel",
  },
  fields: [
    ..._panel_schema_fields_svi,

    // pods_input panel
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "unutrasnjaoplata",
      "tipispuneklimakomore",
      "vrstaprofila",
      "_extra_siframodula", // NOVO 2025-03-18
    ),

    "sirina",
    "visina",
    "kolicina",
    "x1",
    "y1",
    "d1",
    "x2",
    "y2",
    "d2",
    "a",
    "b",
    "a2",
    "b2",
    "c",
    "d",
    "e",
    "f",
    "eliminatorkapi",
    "smervazduha",
    "kljuc",
    "sigurnosnabrava",
    "revizioniotvor",

    "vremeopsklapanje",
  ]
};

schema_lib.terkk$panel$derivat1 = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "PP"
  },
  fields: [
    ..._schema_default_fields,

    "virtelclass",
    "termaterijal",
    "cncprogram1", // NOVO
    "sistempanela",
    "tipkomore",
    "unutrasnjaoplata",
    "tipispuneklimakomore",
    "tippanela",
    /*
    {
      name: "tippanela",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
      type: TYPE_STRING,
      size: 100,
    },
    */
    "kljuc",
    "sigurnosnabrava",
    "sirina",
    "visina",
    "calculated_ident",
    "duzina",
    "sirina",
    "sirinarazvijena",
    "naziv",
    "tip",
    "leviger",
    "desniger",
  ]
};

schema_lib.terkk$panel$materijal1 = {
  program: {
    default_graphlevel: 4,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "tip",
    "duzina",
    // "I999", ???
    "naziv",
    "calculated_ident",
  ]
};

schema_lib.terkk$panel$materijal2 = {
  program: {
    default_graphlevel: 4,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M",
  },
  fields: [
    ..._schema_default_fields,

    "sistempanela",
    "tipkomore",
    "unutrasnjaoplata",
    "tipispuneklimakomore",
    "tippanela",
    "kljuc",
    "sigurnosnabrava",
    "sirina",
    "visina",
    "calculated_ident",
    "naziv",
  ]
};



// terkk$demper

schema_lib.terkk$demper = {
  program: {
    default_graphlevel: 3,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$demper",
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "demper",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$demper",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "tipdempera",
    "unutrasnjasirina",
    "unutrasnjavisina",
    "vrstapogona",
    "osovina",
    "display_brojkrilaca",
    "kolicina",
  ]
};
/*
DEMPER
display_brojkrilaca se nalazi u definiciji forme za demper i on se koristi za lazno polje, dakle to nije LOCALS nego DERIVAT...
*/

schema_lib.terkk$demper$derivat1 = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: true
  },
  fixed_fields: {
    jm: "kom",
    terkategorija: "PP"
  },
  fields: [
    ..._schema_default_fields,

    /*
    {
      name: "unutrasnjasirina",
      sect: SECT_INPUT,
      pods: {
        pods_input: true,
      },
    },
    "brojkrilaca",
    */
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};

schema_lib.terkk$demper$materijal1 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    // "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};

schema_lib.terkk$demper$materijal2 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    /*
    "unutrasnjasirina",
    "brojkrilaca",
    */
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};



// terkk$elasticnaveza

schema_lib.terkk$elasticnaveza = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$elasticnaveza",
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "elasticnaveza",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$elasticnaveza",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "prirubnica",
    "platno",
    "sirinaa",
    "visinab",
    "montiranjenademper",
    "kolicina",
  ]
};

schema_lib.terkk$elasticnaveza$derivat1 = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: true
  },
  fixed_fields: {
    jm: "kom",
    terkategorija: "PP",
  },
  fields: [
    ..._schema_default_fields,
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};

schema_lib.terkk$elasticnaveza$materijal1 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M",
  },
  fields: [
    ..._schema_default_fields,
    "naziv",
    "tip",
    "calculated_ident",
  ]
};

schema_lib.terkk$elasticnaveza$materijal2 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};



// terkk$eliminatorkapi

const schema_bundle_eliminatorkapi = {
  // SAMO ZA FRONTEND
  // TODO: iako se ovaj koristi samo na frontendu FRONTEND_ONLY, radi upotrebe pomocnih funkcija i preglednosti i on mora da ima svoju semu
  program: {
    frontend_only: true,
    default_graphlevel: 3,
    use_genus: false,
    use_autocreate: false
  },
  fields: []
};

schema_lib.terkk$eliminatorkapi = {
  // TODO: elimintaor_kapi ZAHTEVA NOVO RESENJE jer je neobican i naknadno se izracujava... i sastoji se od nekolko dinamickiih pod formi
  program: {
    default_graphlevel: 3,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$eliminatorkapi",
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "eliminatorkapi",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$eliminatorkapi",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    // pods_input eliminatorkapi
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "msirinaunutrasnja",
      "mvisinaunutrasnja",
      "_extra_siframodula", // NOVO 2025-03-18
    ),

    "bundle_id",
    "tipeliminatorakapi",
    "sirina",
    "visina",
    "kolicina",
  ]
};

schema_lib.terkk$eliminatorkapi$derivat1 = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: true
  },
  fixed_fields: {
    jm: "kom",
    terkategorija: "PP"
  },
  fields: [
    ..._schema_default_fields,

    // "visina",
    // "sirina",
    // "pbrojkomada",
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};

schema_lib.terkk$eliminatorkapi$materijal1 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    {
      name: "duzina",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
    },
    /*
    {
      name: "tip",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
    },
    */
    "tip",
    "naziv",
    "calculated_ident",
  ]
};

schema_lib.terkk$eliminatorkapi$materijal2 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    /*
    "visina",
    "sirina",
    "pbrojkomada",
    */
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};


// terkk$spoljnafiksnazaluzina

schema_lib.terkk$spoljnafiksnazaluzina = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$spoljnafiksnazaluzina",
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "spoljnafiksnazaluzina",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$spoljnafiksnazaluzina",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "tipspoljnefiksnezaluzine",
    "unutrasnjasirina",
    "unutrasnjavisina",
    "kolicina",
  ]
};

schema_lib.terkk$spoljnafiksnazaluzina$derivat1 = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "PP"
  },
  fields: [
    ..._schema_default_fields,

    /*
    {
      name: "unutrasnjasirina",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
    },
    */
    "unutrasnjasirina",
    /*
    {
      name: "unutrasnjavisina",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
    },
    */
    "unutrasnjavisina",
    "duzina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};

schema_lib.terkk$spoljnafiksnazaluzina$materijal1 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    {
      name: "duzina",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
    },
    /*
    {
      name: "tip",
      sect: SECT_GENUS,
      pods: {
        pods_input: true,
      },
    },
    */
    "tip",
    "naziv",
    "calculated_ident",
  ]
};

schema_lib.terkk$spoljnafiksnazaluzina$materijal2 = {
  program: {
    default_graphlevel: 4,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "duzina",
    "sirina",
    "naziv",
    "tip",
    "calculated_ident",
  ]
};


// Abecedni deo redosleda Ispod SFZ a iznad postolja


// terkk$kadica

schema_lib.terkk$kadica = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$kadica",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "KADICA",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$kadica",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    // pods_input kadica
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      // "vrstaprofila",
      // "msirinaunutrasnja",
      "msirinaunutrasnjaizmedjuosnovnih",
      "siframodula",
    ),

    "virtelclass",
    "termaterijal",
    "cnccrtez", // NOVO
    "tip",
    "naziv",
    // "duzina",
    // "sirina",
    {
      name: "duzina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "kadica_duzina_preporucena",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "sirina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    "odvodkondenzata",
    "kolicina",
  ]
};

schema_lib.terkk$kadica$materijal1 = {
  program: {
    // default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "tip",
    "naziv",
    "calculated_ident",
  ]
};


// //// NOVI KLADOVO
schema_lib.terkk$klizac = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$klizac",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$klizac",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "msirinaunutrasnja",
      "vrstaprofila",
      // "msirinaspoljasnja",
      "duzinamodula",
      "siframodula",
    ),

    // samo
  ]
};
//
schema_lib.terkk$klizac$child = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$klizac$child",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "POSTOLJE_PROFIL",
    terkknivo: null,
    _draftelschemakey: "terkk$klizac$child",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    "termaterijal",
    "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,

  ]
};


//
schema_lib.terkk$klizacramamraztermostata = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$klizacramamraztermostata",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$klizacramamraztermostata",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    "termaterijal",
    "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "msirinaunutrasnjaizmedjupregradnih",
    ),

    // samo
  ]
};


// kucisteelektrogrejaca
schema_lib.terkk$kucisteelektrogrejaca = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$kucisteelektrogrejaca",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
    // _draftelschemakey: "",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "msirinaunutrasnjaizmedjupregradnih",
      "mvisinaunutrasnjaizmedjukrilaca",
    ),

    // samo
    //
  ]
};


// NPR TODO
schema_lib.terkk$npr = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$npr",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$npr",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "vrstaprofila",
      "duzinamodula",
      // "msirinaunutrasnjaizmedjupregradnih", // IZBACITI
      // "mvisinaunutrasnjaizmedjupregradnih", // IZBACITI
      // "mvisinaunutrasnjaizmedjukrilaca", // IZBACITI
      // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
      "msirinaspoljasnja",
      "mvisinaspoljasnja",
    ),


    // samo
  ]
};


// NRR TODO
schema_lib.terkk$nrr = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$nrr",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$nrr",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "vrstaprofila",
      // "msirinaunutrasnjaizmedjupregradnih",
      "msirinaspoljasnja",
      // "mvisinaunutrasnjaizmedjukrilaca",
      "mvisinaspoljasnja",
      "duzinamodula",
    ),

    // samo
  ]
};


//
schema_lib.terkk$nosacventilatora = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$nosacventilatora",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "POSTOLJE_PROFIL",
    terkknivo: null,
    _draftelschemakey: "terkk$nosacventilatora",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    "termaterijal",
    "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "vrstaprofila",
      // "msirinaunutrasnja",
      // "msirinaunutrasnjaizmedjupregradnih",
      "duzinamodula",
      // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
      "msirinaspoljasnja",
    ),

    // samo
  ]
};


// parniovlazivac TODO
schema_lib.terkk$parniovlazivac = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$parniovlazivac",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$parniovlazivac",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      // "ksirinaoznaka",
      // "kvisinaoznaka",
      "vrstaprofila",
      // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
      "msirinaspoljasnja",
      "mvisinaspoljasnja",
      "_extra_siframodula", // NOVO 2025-03-18
    ),

    // samo
  ]
};



// PPD pregradni panel dempera
schema_lib.terkk$ppd = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$ppd",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
    // _draftelschemakey: "",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      // "unutrasnjaoplata",
      "vrstaprofila",
      // "msirinaunutrasnjaizmedjupregradnih",
      // "msirinaunutrasnjaizmedjuosnovnih",
      // "mvisinaunutrasnjaizmedjupregradnih",
      // "mvisinaunutrasnjaizmedjuosnovnih",
      // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
      "msirinaspoljasnja",
      "mvisinaspoljasnja",
    ),

    // samo
    //
  ]
};


// PPV pregradni panel ventilatora
schema_lib.terkk$ppv = {
  program: {
    default_graphlevel: 3,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$ppv",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "ppv",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "vrstaprofila",
      "msirinaunutrasnjaizmedjupregradnih",
      "msirinaunutrasnjaizmedjuosnovnih",
      "mvisinaunutrasnjaizmedjupregradnih",
      "mvisinaunutrasnjaizmedjuosnovnih",
    ),

    // samo ppv
    //
  ]
};
//
schema_lib.terkk$ppv$sekcija = {
  program: {
    default_graphlevel: 5,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$ppv$sekcija",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "ppv$sekcija",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    // ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "msirinaunutrasnjaizmedjupregradnih",
      "msirinaunutrasnjaizmedjuosnovnih",
      "mvisinaunutrasnjaizmedjupregradnih",
      "mvisinaunutrasnjaizmedjuosnovnih",
    ),

    // samo 
    //
  ]
};


// prigusivacbuke TODO
schema_lib.terkk$prigusivacbuke = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$prigusivacbuke",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "mvisinaunutrasnjaizmedjukrilaca",
      "msirinaunutrasnjaizmedjupregradnih",
      "vrstaprofila",

      // OLD
      // "ksirinaoznaka",
      // "kvisinaoznaka",
    ),


    // samo
  ]
};


// protivkisnazaluzina TODO
schema_lib.terkk$protivkisnazaluzina = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$protivkisnazaluzina",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$protivkisnazaluzina",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    /*
    {
      name: "vrstaprofila",
      sect: SECT_INSTANCE,
      pods: {
        pods_input: true,
      },
    },
    */


    // samo
  ]
};


// terkk$ramfiltera TODO
schema_lib.terkk$ramfiltera = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$ramfiltera",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$ramfiltera",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      "vrstaprofila",
      // "msirinaunutrasnjaizmedjupregradnih",
      // "mvisinaunutrasnjaizmedjupregradnih",
      // "mvisinaunutrasnjaizmedjukrilaca",
      //
      // "ksirinaoznaka",
      // "kvisinaoznaka",
      // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
      "msirinaspoljasnja",
      "mvisinaspoljasnja",
    ),

    // samo
  ]
};


//
schema_lib.terkk$ramfilteranauklizavanje = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$kucisteelektrogrejaca",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
    // _draftelschemakey: "terkk$kucisteelektrogrejaca",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "tipkomore",
      // "ksirinaoznaka",
      "kvisinaoznaka",
      // "unutrasnjaoplata",
      "vrstaprofila",
      "msirinaunutrasnjaizmedjupregradnih",
      "mvisinaunutrasnjaizmedjupregradnih"
    ),

    // samo ?
    //
  ]
};
//
schema_lib.terkk$ramfilteranauklizavanje$child = {
  program: {
    default_graphlevel: 5,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$ramfilteranauklizavanje$child",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "ramfilteranauklizavanje$child",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    // ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,


    // samo
    //
  ]
};



// rammraztermostata TODO
schema_lib.terkk$rammraztermostata = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$rammraztermostata",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$rammraztermostata",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      // NOVO
      // rammraztermostata
      "tipkomore",
      "vrstaprofila",
      // "msirinaunutrasnjaizmedjukrilaca", NJ 2024-11-25: IZBACUJEMO
      "mvisinaunutrasnjaizmedjukrilaca",
      // "ksirinaoznaka", // NE TREBA
      // "kvisinaoznaka", // NE TREBA
      // "msirinaunutrasnjaizmedjupregradnih", // NE TREBA
      "msirinaunutrasnjaizmedjupregradnih", // IPAK TREBA
    ),

    // samo
  ]
};


// usmerivacvazduha TODO
schema_lib.terkk$usmerivacvazduha = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$usmerivacvazduha",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$usmerivacvazduha",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    /*
    {
      name: "vrstaprofila",
      sect: SECT_INSTANCE,
      pods: {
        pods_input: true,
      },
    },
    */


    // samo
  ]
};


// Zadnji deo redosleda pocinje od postolja.


// terkk$postolje

schema_lib.terkk$postolje = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    jm: "kom",
    terkategorija: "PP",
    tergrupa: "POSTOLJE",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$postolje",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "vrstaprofila",
      "msirinaspoljasnja",
      "duzinamodula",
    ),

    "sirinaprofilapostolja",

    "tip",
    "naziv",
    // "duzina",
    // "sirina",
    {
      name: "duzina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "sirina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "visina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    "kolicina",
  ]
};


schema_lib.terkk$postolje$profil = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    // virtelclass: "terkk$postolje$profil",
    // jm: "kom",
    // terkategorija: "PP",
    // tergrupa: "POSTOLJE_PROFIL",
    terkknivo: null,
    // _draftelschemakey: "terkk$postolje$profil",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    "termaterijal",
    "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "vrstaprofila",
      "msirinaspoljasnja",
      "duzinamodula",
    ),

    // samo psotolje
    // "naziv",
    {
      name: "smerojacanjapostolja",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "sirinapostolja",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "duzinapostolja",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "visinapostolja",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    // "kolicina",
    "sirinaprofilapostolja",

    // profili postolja
    "duzina",
    // "visina", // visina profila je ista kao visinapostolja
    "dimenzijazapozicije",
    "pozicijaprofila",
    "pozicijaojacanja1",
    "pozicijaojacanja2",
    "pozicijaojacanja3",
    "pozicijaojacanja4",
    "pozicijaojacanja_poduzini_pack",
    "pozicijaojacanja_posirini_pack",
    "pozicijaodvodakondenzata1",
    "pozicijaodvodakondenzata2",
    "pozicijaodvodakondenzata3",
    "pozicijaodvodakondenzata_pack",
    "tip",
    "naziv",
    "kolicina",
  ]
};

schema_lib.terkk$postolje$profil$materijal1 = {
  program: {
    default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,
    "naziv",
    "tip",
    "calculated_ident",
  ]
};


// krov
schema_lib.terkk$krov = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$krov",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "POSTOLJE_PROFIL",
    terkknivo: null,
    _draftelschemakey: "terkk$krov",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "msirinaspoljasnja",
      "duzinamodula",
      "siframodula",
    ),

    // samo
    "tipkrovnogsegmenta",
    "naziv",
    "sirina",
    "duzina",
    {
      name: "povrsina",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
        pods_der: true,
      },
    },
    "kolicina",
    //
    "a",
    "b",
    "x",
    "y",
  ]
};
//
schema_lib.terkk$krov$child = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$krov$child",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "POSTOLJE_PROFIL",
    terkknivo: null,
    _draftelschemakey: "terkk$krov$child",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    "termaterijal",
    "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      "msirinaspoljasnja",
      "duzinamodula",
      "siframodula",
    ),

    // samo
    // "tipkrovnogsegmenta",
    "tip",
    "naziv",
    "sirina",
    "duzina",
    {
      name: "povrsina",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
        pods_der: true,
      },
    },
    "kolicina",
    //
    "a",
    "b",
    "x",
    "y",
  ]
};


// paletapakovanja TODO
schema_lib.terkk$paletapakovanja = {
  program: {
    default_graphlevel: 4,
    use_genus: true,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$paletapakovanja",
    jm: "kom",
    terkategorija: "PP",
    terkknivo: null,
    // _draftelschemakey: "terkk$paletapakovanja",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    ..._pods_input_obj_arr_make(
      // company_orderkey
      // Nosilac troška
      "sifrakomore",
      "siframodula",
    ),
    /*
    {
      name: "vrstaprofila",
      sect: SECT_INSTANCE,
      pods: {
        pods_input: true,
      },
    },
    */


    // samo
  ]
};


// schema_lib.terkk$limcustom

schema_lib.terkk$limcustom = {
  program: {
    // default_graphlevel: 4,
    use_classic_table: true,
    mip_is_materijal: false,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$limcustom",
    terkategorija: "PP"
    // terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_pp,

    {
      name: "identmaterijala", // DUPLIKAT jerje dovoljno "termaterijal"
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    "termaterijal",
    {
      name: "naziv",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },

    /*
    // 2023-07-05 DL: sirinu i duzinu za sad ne vuvamo u bazi samo povrsinu.
    {
      name: "sirina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "duzina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    */
    {
      name: "povrsina",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
        pods_der: true,
      },
    },

    "operacija1",
    "rc1",
    "operacija2",
    "rc2",
    "cnccrtez", // NOVO

    "naziv_materijala", // NOVO
  ]
};

schema_lib.terkk$limcustom$derivat1 = {
  ...schema_lib.terkk$limcustom,
  program: {
    use_autocreate: true
  },
  fixed_fields: {
    virtelclass: "terkk$limcustom$derivat1",
    terkategorija: "PP"
  },
};

schema_lib.terkk$limcustom$materijal1 = {
  program: {
    // default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "tip",
    "naziv",
    "calculated_ident",
  ]
};


// schema_lib.terkk$profilcustom

schema_lib.terkk$profilcustom = {
  program: {
    // default_graphlevel: 4,
    use_classic_table: true,
    mip_is_materijal: false,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$profilcustom",
    // terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_pp,

    {
      name: "identmaterijala", // DUPLIKAT jerje dovoljno "termaterijal"
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    "termaterijal",
    {
      name: "naziv",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },

    {
      name: "duzina",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "leviger",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
    {
      name: "desniger",
      sect: SECT_GENUS,
      pods: {
        pods_own: true,
      },
    },
  ]
};

schema_lib.terkk$profilcustom$materijal1 = {
  // TODO:
  program: {
    // default_graphlevel: 4,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "naziv",
    "calculated_ident",
    "tip",
    // "duzina", // ovo je kolicina
  ]
};


// terkk$materijalcustom

schema_lib.terkk$materijalcustom = {
  program: {
    default_graphlevel: 4,
    use_classic_table: true,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "terkk$materijalcustom",
    terkknivo: "CHILDOFMODUL",
    _draftelschemakey: "terkk$materijalcustom",
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_parametri_za_pp,

    {
      name: "identcustom",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },
    "terkategorija",
    "tergrupacustom",
    {
      name: "naziv",
      sect: SECT_INSTANCE,
      pods: {
        pods_own: true,
      },
    },

    "Par28",
    "Par29",
  ]
};


// materijali NOVO

schema_lib.terkk$materijal_lim = {
  program: {
    // default_graphlevel: 5,
    mip_is_materijal: true,
    use_genus: false,
    use_autocreate: true
  },
  fixed_fields: {
    terkategorija: "M"
  },
  fields: [
    ..._schema_default_fields,

    "tip",
    "naziv",
    "calculated_ident",
  ]
};


// experimental

schema_lib.zzkitc$kitc = {
  program: {
    default_graphlevel: 3,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "zzkitc$kitc",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,

    // samo *

    "tip",
    "naziv",
    "kolicina",
  ]
};
//
schema_lib.zzkitc$kitc$element = {
  program: {
    default_graphlevel: 3,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "zzkitc$kitc$element",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    /*
    {
      name: "kuh_debljina_korpus",
      sect: SECT_INSTANCE,
      pods: {
        pods_input: true,
      },
    },
    */
    ..._pods_input_obj_arr_make(
      "kuh_h_nivoviseci2vrh",
      "kuh_h_viseci2korpus",

      "kuh_h_nivovisecivrh",
      "kuh_h_visecikorpus",
      "kuh_h_nivovisecidno",
      "kuh_h_razmakradni",

      "kuh_h_nivoradna",
      "kuh_h_radnaploca",
      "kuh_h_nivoispodradneploce",
      "kuh_h_korpusdonji",
      "kuh_h_nogare",

      "kuh_d_radnaploca",
      "kuh_d_prazninadozida",
      "kuh_d_korpusipraznina",
      "kuh_d_korpus",
      "kuh_d_deltakorpus",
      "kuh_d_deltafront",

      "kuh_d_prazninazidmaska",
      "kuh_d_maskastrciviseodfronta",
      "kuh_d_maskastrciispredkorpusa",
      "kuh_d_maskastrciispredkorpusa_preporucena",
      "kuh_d_dubina_maske",
      "kuh_d_dubina_maskeolaksane",

      "kuh_d_visecikorpus",
      "kuh_d_razmakzidvisecikorpus",
      "kuh_d_viseci2korpus",

      "kuh_w_frontuziodkorpusa",
      "kuh_h_frontniziodkorpusa",
      "kuh_w_ledjauzaodkorpusa",
      "kuh_h_ledjanizaodkorpusa",

      //
      "kuh_materijal_radnaploca",
      "kuh_debljina_radnaploca", // ALIAS OF kuh_h_radnaploca
      "kuh_materijal_korpusa",
      "kuh_debljina_korpus",
      "kuh_materijal_ledja",
      "kuh_debljina_ledja",
      "kuh_materijal_front",
      "kuh_debljina_front",
      "kuh_debljina_maske",

      //
      "kuh_do_ledja",
      "kuh_do_fronts",
      "kuh_do_wallunits",
      "kuh_do_wallunits2",
      "kuh_do_countertop",
      "kuh_do_sokla",
      "kuh_do_carcass_as_kubus",

      //
    ),




    // samo *

    "tip",
    "naziv",
    "kolicina",
  ]
};
//
schema_lib.zzkitc$kitc$wbp = {
  program: {
    default_graphlevel: 3,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "zzkitc$kitc$wbp",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input postolje koji dolaze od modula i komore
    ...default_schema_fields_flag_custom_pods_input,
    // _pods_input_obj_make("kuh_materijal_radnaploca"),
    // _pods_input_obj_make("kuh_materijal_korpusa"),
    // _pods_input_obj_make("kuh_materijal_ledja"),
    // _pods_input_obj_make("kuh_materijal_front"),

    // samo *

    "tip",
    "naziv",
    "kolicina",
  ]
};
//
schema_lib.zzkitc$kitc$child = {
  program: {
    default_graphlevel: 3,
    use_genus: false,
    use_autocreate: false
  },
  fixed_fields: {
    virtelclass: "zzkitc$kitc$child",
    jm: "kom",
    terkategorija: "PP",
    // tergrupa: "",
    terkknivo: null,
  },
  fields: [
    ..._schema_default_fields,
    ...default_schema_fields_CHILDOFMODUL,
    ...default_schema_fields_parametri_za_pp,

    "virtelclass",
    // "termaterijal",
    // "cncprogram1",

    // pods_input
    ...default_schema_fields_flag_custom_pods_input,

  ]
};



// -------------------------------------------
// ----------UTILS----------------------------

export const _virtel_schema_field_get = (name, sema) => {
  let target = false;
  let field;
  let exit = false;
  let i = 0;
  if (sema && Array.isArray(sema.fields)) {
    while (i < sema.fields.length && exit === false) {
      // sema.fields.forEach((field) => {
      field = sema.fields[i];
      if (field && field.name === name) {
        target = { ...field };
        exit = true;
      }
      i++;
    }
  }
  return target;
};
// exports._virtel_schema_field_get = _virtel_schema_field_get; // Node.js named export


// ALL SEMA KEYS
const virtel_schema_keys = [
  "terkk$klimakomora",
  "terkk$modul",
  "terkk$modul$rogalj",
  "terkk$modul$profilosnovni",
  "terkk$modul$profil_materijal1",
  "terkk$modul$profilpregradni",
  "terkk$panel",
  "terkk$panel$derivat1",
  "terkk$panel$materijal1",
  "terkk$panel$materijal2",
  "terkk$demper",
  "terkk$demper$derivat1",
  "terkk$demper$materijal1",
  "terkk$demper$materijal2",
  "terkk$elasticnaveza",
  "terkk$elasticnaveza$derivat1",
  "terkk$elasticnaveza$materijal1",
  "terkk$elasticnaveza$materijal2",
  "terkk$eliminatorkapi",
  "terkk$eliminatorkapi$derivat1",
  "terkk$eliminatorkapi$materijal1",
  "terkk$eliminatorkapi$materijal2",
  "terkk$spoljnafiksnazaluzina",
  "terkk$spoljnafiksnazaluzina$derivat1",
  "terkk$spoljnafiksnazaluzina$materijal1",
  "terkk$spoljnafiksnazaluzina$materijal2",
  // Abecedni deo redosleda Ispod SFZ a iznad postolja
  "terkk$kadica",
  "terkk$kadica$materijal1",
  "terkk$klizac", // ???
  "terkk$klizac$child", // ???
  "terkk$klizacramamraztermostata", // ovi ???
  "terkk$kucisteelektrogrejaca", // proveriti
  "terkk$npr", // NPR TODO
  "terkk$nrr", // NRR TODO
  "terkk$nosacventilatora", // ???
  "terkk$parniovlazivac", // parniovlazivac TODO
  "terkk$ppd",
  "terkk$ppv",
  "terkk$ppv$sekcija",
  "terkk$prigusivacbuke", // prigusivacbuke TODO
  "terkk$protivkisnazaluzina", // protivkisnazaluzina TODO
  "terkk$ramfiltera", // ramfiltera TODO
  "terkk$ramfilteranauklizavanje", // NOVI
  "terkk$ramfilteranauklizavanje$child", // NOVI
  "terkk$rammraztermostata", // rammraztermostata TODO
  "terkk$usmerivacvazduha", // usmerivacvazduha TODO
  // Zadnji deo redosleda pocinje od postolja.
  "terkk$postolje",
  "terkk$postolje$profil",
  "terkk$postolje$profil$materijal1",
  "terkk$krov",
  "terkk$krov$child",
  "terkk$paletapakovanja", // Zadnja je paleta // TODO 
  //
  "terkk$limcustom",
  "terkk$limcustom$derivat1",
  "terkk$limcustom$materijal1",
  "terkk$profilcustom",
  "terkk$profilcustom$materijal1",
  "terkk$materijalcustom",
  // materijali
  "terkk$materijal_lim",
  // experimental
  "zzkitc$kitc",
  "zzkitc$kitc$element",
  "zzkitc$kitc$wbp",
  //
  "terkk$temp",
];


export const virtel_schema_init = () => {
  // INIT I OPTIMIZACIJA SEMA
  console.log('INIT virtel_schema_init() ');
  virtel_schema_keys.forEach((key) => {
    //
    if (virtel_schema_keys.includes(key) && schema_lib[key] && schema_lib[key].program && schema_lib[key].fields) {
      // return schema_lib[key]; // vracamo trazemu semu
      // console.log('*****');
      // console.log('key', key);
      let _fields = [];
      let _pods_input_fields = [];
      schema_lib[key].fields.forEach((field) => {
        // console.log(field);
        let field_prepared = {};
        let name;
        if (typeof field === 'string') {
          // CASE virtel_schema field koristi default field vrednosti
          name = field;
          field_prepared = {
            ...virtel_field_schema_smart_get(name)
          };
        } else {
          // virtel_schema field PREGAZI default field vrednosti
          name = field.name;
          field_prepared = {
            ...virtel_field_schema_smart_get(name),
            ...field
          };
        }
        // PREPARE pods_input_fileds schema
        if (field_prepared.pods && field_prepared.pods.pods_input === true) {
          let pods_input_field_type;
          let default_value = null;
          if (field_prepared.type === TYPE_STRING) {
            pods_input_field_type = TYPE_STRING;
            default_value = "";
          } else if (field_prepared.type === TYPE_INTEGER) {
            pods_input_field_type = TYPE_INTEGER;
            default_value = null;
          } else if (field_prepared.type === TYPE_FLOAT) {
            pods_input_field_type = TYPE_FLOAT;
            default_value = null;
          } else if (field_prepared.type === TYPE_BOOL) {
            pods_input_field_type = TYPE_BOOL;
            default_value = null;
          }
          _pods_input_fields.push({
            name: name,
            type: pods_input_field_type,
            default_value: default_value,
          });
        }
        //
        _fields.push(field_prepared);
      }); // end of forEach field
      const _virtel_schema_optimized = {
        ...schema_lib[key],
        fields: _fields
      };
      if (Array.isArray(_pods_input_fields) && _pods_input_fields.length > 0) {
        // add pods_input_fields to virtel schema
        _virtel_schema_optimized.pods_input_fields = _pods_input_fields;
      }
      schema_lib_optimized[key] = _virtel_schema_optimized;
    }
    //
  });
  schema_lib_initialized = true;
  console.log('INIT optimizacija virtel definicija i zavrsena');
  console.log('schema_lib_optimized');
  console.log(schema_lib_optimized);
  return true;
};
// exports.virtel_schema_init = virtel_schema_init; // Node.js named export


//
export const virtel_schema_smart_get = (virtelschemakey) => {
  const key = virtelschemakey;

  if (schema_lib_initialized === false) {
    console.log('WARNING virtel schema_lib is not initialized. We will initialize it now.');
    virtel_schema_init();
  }

  const old = {
    // OLD switch
    /*
    // U OVU FUNKCIJU OBAVEZNO PEDANTNO UPISATI SVE SEME
    switch (key) {
  
      case "terkk$klimakomora":
        return schema_lib.terkk$klimakomora;
  
  
      case "terkk$modul":
        return schema_lib.terkk$modul;
  
      case "terkk$modul$rogalj":
        return schema_lib.terkk$modul$rogalj;
      case "terkk$modul$profilosnovni":
        return schema_lib.terkk$modul$profil;
      case "terkk$modul$profil_materijal1":
        return schema_lib.terkk$modul$profil_materijal1;
      case "terkk$modul$profilpregradni":
        return schema_lib.terkk$modul$profilpregradni;
  
  
      case "terkk$panel":
        // malo komplikovan
        return schema_lib.terkk$panel;
      case "terkk$panel$derivat1":
        return schema_lib.terkk$panel$materijal1;
      case "terkk$panel$materijal1":
        return schema_lib.terkk$panel$materijal1;
      case "terkk$panel$materijal2":
        return schema_lib.terkk$panel$materijal2;
  
  
      case "terkk$demper":
        return schema_lib.terkk$demper;
  
      case "terkk$demper$derivat1":
        return schema_lib.terkk$demper$derivat1;
      case "terkk$demper$materijal1":
        return schema_lib.terkk$demper$materijal1;
      case "terkk$demper$materijal2":
        return schema_lib.terkk$demper$materijal2;
  
  
      case "terkk$elasticnaveza":
        return schema_lib.terkk$elasticnaveza;
  
      case "terkk$elasticnaveza$derivat1":
        return schema_lib.terkk$elasticnaveza$derivat1;
      case "terkk$elasticnaveza$materijal1":
        return schema_lib.terkk$elasticnaveza$materijal1;
      case "terkk$elasticnaveza$materijal2":
        return schema_lib.terkk$elasticnaveza$materijal2;
  
  
      case "terkk$eliminatorkapi":
        // malo komplikovan
        return schema_lib.terkk$eliminatorkapi;
  
      case "terkk$eliminatorkapi$derivat1":
        return schema_lib.terkk$eliminatorkapi$derivat1;
      case "terkk$eliminatorkapi$materijal1":
        return schema_lib.terkk$eliminatorkapi$materijal1;
      case "terkk$eliminatorkapi$materijal2":
        return schema_lib.terkk$eliminatorkapi$materijal2;
  
  
      case "terkk$spoljnafiksnazaluzina":
        return schema_lib.terkk$spoljnafiksnazaluzina;
  
      case "terkk$spoljnafiksnazaluzina$derivat1":
        return schema_lib.terkk$spoljnafiksnazaluzina$derivat1;
      case "terkk$spoljnafiksnazaluzina$materijal1":
        return schema_lib.terkk$spoljnafiksnazaluzina$materijal1;
      case "terkk$spoljnafiksnazaluzina$materijal2":
        return schema_lib.terkk$spoljnafiksnazaluzina$materijal2;
  
  
      case "terkk$materijalcustom":
        return schema_lib.terkk$materijalcustom;
  
      default:
        // console.log('GRESKA! virtel_schema_smart_get default, no case matched - key is: ', key);
        console.log('%c' + 'GRESKA! virtel_schema_smart_get default, no case matched - key is: ' + key, 'background-color: #c8c0f6;border-radius-top-left:10px;padding:1px;padding:1px;padding-left:5px');
  
        
        // log_string = '%c' + 'minimal_ajax_get BEFORE  ' + description + '  ' + fetch_url;
        // console.log(log_string, 'background-color: #c8c0f6;border-radius-top-left:10px;padding:1px;padding:1px;padding-left:5px');
        //
        return false;
    }; // end of switch
    */
  };

  const schema_lib = schema_lib_optimized; // koristimo optimizovanu semu
  if (virtel_schema_keys.includes(key) && schema_lib[key] && schema_lib[key].program && schema_lib[key].fields) {
    // return schema_lib[key]; // vracamo trazemu semu
    /*
    console.log('*****')
    console.log('key', key);
    let _fields = [];
    schema_lib[key].fields.forEach((field) => {
      console.log(field);
      if (typeof field === 'string') {
        _fields.push({
          ...virtel_field_schema_smart_get(field)
        });
      } else {
        // virtel_schema field PREGAZI default field vrednosti
        _fields.push({
          ...virtel_field_schema_smart_get(field),
          ...field
        });
      }
    });
    console.log(_fields)
    let sema = {
      ...schema_lib[key],
      fields: _fields
    };
    */
    // console.log('sema');
    // console.log(sema);
    // console.log(schema_lib[key]);
    // return sema; // vracamo trazemu semu
    return schema_lib[key]; // vracamo trazemu optimizovanu semu
  } else {
    // VIRTEL SCHEMA NOT FOUND
    // console.log('GRESKA! virtel_schema_smart_get default, no case matched - key is: ', key);
    console.log('%c' + 'GRESKA! virtel_schema_smart_get default, no case matched - key is: ' + key, 'background-color: #c8c0f6;border-radius-top-left:10px;padding:1px;padding:1px;padding-left:5px');

    // log_string = '%c' + 'minimal_ajax_get BEFORE  ' + description + '  ' + fetch_url;
    // console.log(log_string, 'background-color: #c8c0f6;border-radius-top-left:10px;padding:1px;padding:1px;padding-left:5px');
    //
    return false;
  }
};
// exports.virtel_schema_smart_get = virtel_schema_smart_get; // Node.js named export


//
export const virtel_pods_input_schema_smart_get = (virtelschemakey) => {
  const sema = virtel_schema_smart_get(virtelschemakey);
  if (sema && sema.pods_input_fields && Array.isArray(sema.pods_input_fields)) {
    return sema.pods_input_fields;
  }
  return false;
};


//
export const default_pods_input_state_smart_get = (virtelschemakey) => {
  const sema = virtel_schema_smart_get(virtelschemakey);
  let default_pods_input_state = {};
  if (sema && sema.pods_input_fields && Array.isArray(sema.pods_input_fields)) {
    sema.pods_input_fields.forEach((field) => {
      const field_name = field.name;
      default_pods_input_state[field_name] = field.default_value;
    });
  }
  return default_pods_input_state;
};


//
export const _dev_testing_virtel_schema_fields = () => {
  let fobj = {}; // fields object
  let fobj_errors = [];
  let f_pods_input_keys = [];
  // all fields from virtel schema
  virtel_schema_keys.forEach((key) => {
    const sema = virtel_schema_smart_get(key);
    if (sema && sema.program && sema.fields) {
      sema.fields.forEach((field) => {
        const name = field.name;
        if (fobj[name]) {
          // field already used
          let _sect_obj = {
            ...fobj[name].sect_obj
          };
          _sect_obj[field.sect] = true; // single sect
          let _pods_obj = {
            ...fobj[name].pods_obj
          };
          if (field.pods) {
            Object.keys(field.pods).forEach((pods) => {
              _pods_obj[pods] = true;
              if (pods === 'pods_own') {
                fobj[name].used_pods_own_count = fobj[name].used_pods_own_count + 1;
              }
              if (pods === 'pods_input') {
                fobj[name].used_pods_input_count = fobj[name].used_pods_input_count + 1;
                if (f_pods_input_keys.includes(name)) {
                  // already included
                } else {
                  f_pods_input_keys.push(name);
                }
              }
            });
          }
          fobj[name] = {
            ...fobj[name],
            sect_obj: _sect_obj,
            pods_obj: _pods_obj,
            used_count: fobj[name].used_count + 1,
            used_in: [...fobj[name].used_in, key]
          };
        } else {
          // field first time use
          let _pods_obj = {};
          let _pods_obj_count = {
            used_pods_own_count: 0,
            used_pods_input_count: 0
          };
          if (field.pods) {
            Object.keys(field.pods).forEach((pods) => {
              _pods_obj[pods] = true;
              if (pods === 'pods_own') {
                _pods_obj_count.used_pods_own_count = 1;
              }
              if (pods === 'pods_input') {
                _pods_obj_count.used_pods_input_count = 1;
              }
            });
          }
          fobj[name] = {
            ...field,
            sect_obj: {
              [field.sect]: true
            },
            pods_obj: _pods_obj,
            used_count: 1,
            ..._pods_obj_count,
            used_in: [key]
          };
          //
          //
          //
        }
      });
    } else {
      fobj_errors.push(key);
    }
  });
  //
  const fields_from_virtel_schema_arr = [];
  Object.keys(fobj).forEach((name) => {
    fields_from_virtel_schema_arr.push(fobj[name]);
  });
  //
  //

  // NOVO ZA FIELDS
  let fs_obj = {}; // field schema object
  virtel_field_schema_lib.forEach((field) => {
    const name = field.name; // field schema name
    if (fs_obj[name]) {
      // field already used
      let _sect_obj = {
        ...fs_obj[name].sect_obj
      };
      _sect_obj[field.sect] = true; // single sect
      let _pods_obj = {
        ...fs_obj[name].pods_obj
      };
      if (field.pods) {
        Object.keys(field.pods).forEach((pods) => {
          _pods_obj[pods] = true;
        });
      }
      fs_obj[name] = {
        ...fs_obj[name],
        sect_obj: _sect_obj,
        pods_obj: _pods_obj,
        used_count: fs_obj[name].used_count + 1,
        // used_in: [...fs_obj[name].used_in, key]
      };
    } else {
      // first time use
      let _pods_obj = {};
      if (field.pods) {
        Object.keys(field.pods).forEach((pods) => {
          _pods_obj[pods] = true;
        });
      }
      fs_obj[name] = {
        ...field,
        sect_obj: {
          [field.sect]: true
        },
        pods_obj: _pods_obj,
        used_count: 1,
        // used_in: [key]
      };
    }
  });
  //
  const fs_arr = [];
  Object.keys(fs_obj).forEach((name) => {
    fs_arr.push(fs_obj[name]);
  });
  //
  return {
    fields_from_virtel_schema_obj: fobj,
    fields_from_virtel_schema_arr: fields_from_virtel_schema_arr,
    fobj_errors,
    virtel_field_schema_obj: fs_obj,
    virtel_field_schema_arr: fs_arr,
    f_pods_input_keys: f_pods_input_keys.sort(),
  };
};

